

exports.__esModule = true;
exports.module = undefined;

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _module = _angular2['default'].module;
exports.module = _module;


//////////////////
// WEBPACK FOOTER
// ../node_modules/squid/dist/ng/module.js
// module id = ../node_modules/squid/dist/ng/module.js
// module chunks = 0